export default __webpack_public_path__ + "static/media/with-expert.42eb5600.svg";